import { gql } from '@apollo/client';

/* ── AMCs (empanelment) ─────────────────────────────────────── */

export const GET_AMCS = gql`
  query GetAmcs($empanelledOnly: Boolean = false) {
    getAmcs(empanelledOnly: $empanelledOnly) { id name displayName isEmpanelled logoUrl }
  }
`;
